import { render, staticRenderFns } from "./materialReduceCost.vue?vue&type=template&id=d7c373f0"
import script from "./materialReduceCost.vue?vue&type=script&lang=js"
export * from "./materialReduceCost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports